import { useEffect } from 'react';
import TicketSearch from "../components/tickets/TicketSearch";
import Footer from '../components/footers/Footer';
import ApplicationBar from '../components/shared/ApplicationBar';
import logo from '../logo.png';

const Tickets = () => {
    useEffect(() => {
        document.title = 'FestiShare Support - Tickets';
    }, []);

    return (
        <div>
            <div className="w-full flex justify-center">
                <img className="flex justify-center shadow rounded-xl" src={logo} alt="Logo" width={63} />
            </div>
            <TicketSearch />
            <Footer />
            <ApplicationBar />
        </div>
    );
};

export default Tickets;
